export const STATUS = {
  SUCCESS: 'success',
  LOADING: 'loading',
  PENDING: 'pending',
  ERROR: 'error'
};

export const CREATE_CONTRACT_STATUS = {
  SUCCESS: 'success',
  FAIL: 'fail',
  PENDING: 'pending'
};